<template>
<div style="height: 100%">
    <div id="evolve">Evolve</div>
    <div class="row" id="content">
        <div class="col d-flex flex-row align-items-center">
            <div id="form">
                <form @submit.prevent="signup">
                    <div class="row">
                        <h1 id="title">Sign Up</h1>
                    </div>
                    <!-- <div class="row">
                        <div class=" col-5">
                            <input name="name" id="name" placeholder="NAME" v-model="name" class="form-control"/>
                        </div>
                        <div class="col-7">
                            <input name="email" id="email" placeholder="EMAIL" v-model="email" class="form-control">
                        </div>          
                    </div> -->
                    <!-- <div class="form-group">
                        <input name="name" id="name" placeholder="NAME" v-model="name" class="form-control"/>                    
                    </div> -->
                    <p v-if="feedback" class="feedback">{{feedback}}</p>
                    <div class="form-group">
                            <input name="email" id="email" placeholder="EMAIL" v-model="email" class="form-control">
                    </div>
                    <div class="form-group">
                        <input type="password" name="password" id="password" placeholder="CHOOSE A PASSWORD" v-model="password" class="form-control"/>
                    </div>
                    <div class="d-flex flex-column">
                    <div> 
                        
                        <button type="submit" class="btn btn-primary" v-if="!loading">CREATE ACCOUNT</button>
                    </div>
                    <div class="row bottomline">
                        <p >Already have an account? 
                        <router-link :to="{name: 'Login'}"><span id="login">Log in</span></router-link>
                        </p>
                    </div>
                    </div>
                    <div v-if="loading">
                        <p>Loading...</p>
                    </div>
                </form> 
                    
            </div>
        </div>
        <!-- <div class="col d-flex flex-row justify-content-center align-items-center">
            <div id="writing">
                <div class="upperwriting d-flex flex-column align-items-end">
                    <p>20K+ CUSTOMERS</p>
                </div>
                <div class="bottomwriting d-flex flex-column align-items-end">
                    <p>60+ EMPLOYEES WORLDWIDE</p>
                </div>
            </div>
        </div>-->
    </div> 
</div>
</template>
<script>
import firebase from '@/firebase/init'
export default {  
    name: 'SignUp',
    data(){
        return{
            email: null,
            password: null,
            loading: false,
            feedback: null
        }
    },
    methods:{
        signup(){
            var db = firebase.firestore()
            if(this.email && this.password){
                this.loading = true
                firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                .then(cur=>{
                    cur.user.updateProfile({
                        displayName: this.name
                    })
                    .then(()=>{
                        db.collection('users').add({
                            Approved: false,
                            BriefDescription: '',
                            CompanyName: '',
                            Description: '',
                            Email: cur.user.email,
                            Icon: '',
                            Logo: '',
                            FirstName: '',
                            LastName: '',
                            OnBoardingCompleted: false,
                            Role: '',
                            UID:  cur.user.uid
                        }).then(()=>{
                            this.$router.push({name: 'Step1', params: {uid: cur.user.uid, previousfirstname: null, previouslastname: null, previousemail: cur.user.email, previousrole: null, previousspiritanimal: null, previousicon: null, previouscompanyName: null,
                            previousbriefdescription: null, previouslogo: null, previousdescription: null}} )
                        }).catch(err=>{
                            console.log(err);
                        })
                    })
                    .catch(err=>{
                        console.log(err);
                    })
                })
                .catch(err=>{
                    this.feedback = err.message
                    this.loading = false
                })
                this.feedback = null
            }
            else{
                this.feedback = "You must enter all fields"
            }
        }
    },
    beforeCreate: function() {
            document.body.className = 'signup'
            this.$parent.showNavbar = false        
        }
}
</script>
<style scoped>
.feedback{
    color: red;
}
#evolve{
    font-family: GothamRndSSm-Light;
    font-size: 22px;
    color: black;
    margin: 0 0 0 5em;
    height: 5%;
    text-align: start;
    bottom: 0;
    text-anchor: end;
    margin-top: 3em;
}
.form-control{
    border-color: black;
    height: 3.5em;
    margin-top: 1.5em;
    padding-left: 1.5em;
    border-radius: 0.5em;
    line-height: normal;
    line-height: 32px;
}
.btn{
    font-size: 0.7em !important;
    height: 5em;
    width: 50%;
    right: 0;
    margin-top: 1.5em;
    float: left;
    background-color: #5D38DB;
    font-family: GothamRndSSm-Book;
    border-radius: 0.5em;
    line-height: inherit;
}
::placeholder {
  color: black !important;
  font-family: GothamRndSSm-Book;
  font-size: 10px !important;

}
#form{
    width: 30em;
    margin-left: 10em;
}
#title{
    color: black;
    font-size: 40px;
    font-family: GothamRndSSm-Light;
}
p{
    margin-top: 1.5em;
    margin-bottom: 3em;
    
}
.row h1{
    margin-left: 0.5em;
    margin-bottom: 0.8em;
}
.bottomline p{
    margin-left: 1em;
    font-weight: 500;
    font-size: 12px;
    margin-top: 1.5em;
    margin-bottom: 3em;
    color: black;
    font-family: GothamRndSSm-Book;
}
#login{
    color: black;
    font-family: GothamRndSSm-Book;
    font-size: 12px;
    cursor: pointer;
    font-weight: 500;
}
#writing{
    margin-bottom: 9em;

}
.upperwriting p{
    color: black;
    font-size: 42px !important;
    font-family: GothamRndSSm-Light;
    margin: 0;
    float: right;
    letter-spacing: 2px;
}
.bottomwriting p{
    font-size: 22px !important;
    margin: 0;
    margin-left: auto;
    color: black;
    font-family: GothamRndSSm-Book;
    letter-spacing: 1px;
}
#content{
    margin-left: 0;
    margin-right: 0;
    height: 90%;
}
@media (max-width: 700px) {
    #evolve{
        margin-left: 3em;
    }
    #form{
        margin-left: 2em;
    }
}
@media (max-width: 600px) {
    #evolve{
        padding-top: 0;
        margin-top: 2em;
        margin-left: 1em;
    }
    #form{
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue